var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.noVersion)?_c('Alert',{attrs:{"type":"error","message":_vm.formatMessage(_vm.commonLocale.NoVersionGroupMsg),"show-icon":""}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }